import "./adminJobs.css";
import { useEffect, useState } from "react";
import Sidebar from "../../Components/3rd page(Dashboard)/sidebar";

const API = "http://localhost:3001/jobs";
const APPLICATION_API = "http://localhost:3001/applications";

const emptyJob = {
  title: "",
  company: "",
  salary: "",
  location: "",
  type: "Full Time",
  qualification: "",
  experience: "",
  vacancies: "",
  deadline: "",
  description: "",
  status: "Active",
};


function AdminJobs() {
  const [showApplicants, setShowApplicants] = useState(false);

const [applicants, setApplicants] = useState([]);

const [selectedJob, setSelectedJob] = useState(null);

  const [collapsed, setCollapsed] = useState(false);

  const [jobs, setJobs] = useState([]);

  const [search, setSearch] = useState("");

  const [editingId, setEditingId] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [job, setJob] = useState(emptyJob);

  useEffect(() => {
    fetchJobs();
  }, []);

  /* ===========================
        FETCH JOBS
  =========================== */

  const fetchJobs = async () => {
    try {
      const response = await fetch(API);

      const data = await response.json();

      setJobs(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);

      setJobs([]);
    }
  };

  /* ===========================
        INPUT CHANGE
  =========================== */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setJob((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* ===========================
        OPEN ADD MODAL
  =========================== */

  const openAddJob = () => {
    setEditingId(null);

    setJob(emptyJob);

    setShowModal(true);
  };

  /* ===========================
        EDIT JOB
  =========================== */

  const editJob = (item) => {
    setEditingId(item.id);

    setJob({
      title: item.title || "",
      company: item.company || "",
      salary: item.salary || "",
      location: item.location || "",
      type: item.type || "Full Time",
      qualification: item.qualification || "",
      experience: item.experience || "",
      vacancies: item.vacancies || "",
      deadline: item.deadline || "",
      description: item.description || "",
      status: item.status || "Active",
    });

    setShowModal(true);
  };

  /* ===========================
        SAVE JOB
  =========================== */

  const saveJob = async (e) => {
    e.preventDefault();

    const payload = {
      ...job,

      vacancies: Number(job.vacancies),
    };

    try {
      if (editingId) {
        await fetch(`${API}/${editingId}`, {
          method: "PUT",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(payload),
        });
      } else {
        await fetch(API, {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(payload),
        });
      }

      setJob(emptyJob);

      setEditingId(null);

      setShowModal(false);

      fetchJobs();
    } catch (err) {
      console.error(err);
    }
  };

  /* ===========================
        DELETE JOB
  =========================== */

const [deleteModal, setDeleteModal] = useState(false);
const [deleteId, setDeleteId] = useState(null);


const deleteJob = (id) => {

    setDeleteId(id);

    setDeleteModal(true);

};



const confirmDeleteJob = async () => {

    try {

        await fetch(`${API}/${deleteId}`, {

            method:"DELETE",

        });


        setDeleteModal(false);

        setDeleteId(null);

        fetchJobs();


    } catch(err){

        console.error(err);

    }

};
const viewApplicants = async (job) => {
  try {
    const res = await fetch(APPLICATION_API);
    const data = await res.json();

    console.log("All applications:", data);

    const filtered = data.filter(
      (app) => String(app.jobId) === String(job.id)
    );

    console.log("Filtered:", filtered);

    setApplicants(filtered);
    setSelectedJob(job);
    setShowApplicants(true);

  } catch (err) {
    console.log(err);
  }
};
const downloadApplicants = async (job) => {
  try {
    const res = await fetch(APPLICATION_API);
    const data = await res.json();

    const applicants = data.filter(
      (app) => String(app.jobId) === String(job.id)
    );

    if (applicants.length === 0) {
      alert("No applicants found.");
      return;
    }

    const headers = [
      "Full Name",
      "Email",
      "Phone",
      "Registration No",
      "Company",
      "Position",
      "Salary",
      "Status",
      "Applied Date",
      "Resume",
      "Cover Letter",
    ];

    const rows = applicants.map((app) => [
      app.fullname,
      app.email,
      app.phone,
      app.registrationNo,
      app.company,
      app.position,
      app.salary,
      app.status,
      app.appliedAt,
      app.resume,
      app.coverLetter,
    ]);

    let csv =
      headers.join(",") +
      "\n" +
      rows
        .map((row) =>
          row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${job.company}_${job.title}_Applicants.csv`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

  } catch (err) {
    console.error(err);
    alert("Failed to download applicants.");
  }
};

  /* ===========================
        CLOSE MODAL
  =========================== */

  const closeModal = () => {
    setShowModal(false);

    setEditingId(null);

    setJob(emptyJob);
  };

  /* ===========================
        SEARCH
  =========================== */

  const filteredJobs = jobs.filter((item) => {
    const q = search.toLowerCase();

    return (
      item.title.toLowerCase().includes(q) ||
      item.company.toLowerCase().includes(q)
    );
  });

  return (<div className="admin_jobs_layout">

  <Sidebar
    collapsed={collapsed}
    setCollapsed={setCollapsed}
  />

  <div
    className={`admin_jobs_main ${
      collapsed ? "collapsed_main" : ""
    }`}
  >

    {/* =========================
          TOPBAR
    ========================= */}

    <div className="admin_jobs_topbar">

      <div>

        <h1 className="admin_jobs_heading">
          Manage Jobs
        </h1>

        <p className="admin_jobs_subheading">
          Create, edit and manage placement opportunities.
        </p>

      </div>

      <div className="admin_jobs_topbar_right">

        <div className="admin_jobs_search">

          <input
            type="text"
            placeholder="Search jobs..."
            value={search}
            onChange={(e) =>
              setSearch(e.target.value)
            }
          />

        </div>

        <button
          className="admin_jobs_add_btn"
          onClick={openAddJob}
        >
          + Add Job
        </button>

      </div>

    </div>

    {/* =========================
          STATS
    ========================= */}

    <div className="job-stats">

      <div className="stat-card">

        <h3>{jobs.length}</h3>

        <span>Total Jobs</span>

      </div>

      <div className="stat-card">

        <h3>
          {
            jobs.filter(
              (j) => j.status === "Active"
            ).length
          }
        </h3>

        <span>Active Jobs</span>

      </div>

      <div className="stat-card">

        <h3>
          {
            jobs.filter(
              (j) => j.status === "Closed"
            ).length
          }
        </h3>

        <span>Closed Jobs</span>

      </div>

    </div>

    {/* =========================
          TABLE
    ========================= */}

    <div className="job-table-wrapper">

      <table className="job-table">

        <thead>

          <tr>

            <th>Job</th>

            <th>Company</th>

            <th>Location</th>

            <th>Salary</th>

            <th>Status</th>

            <th>Deadline</th>

            <th>Actions</th>

          </tr>

        </thead>

        <tbody>

          {filteredJobs.length === 0 ? (

            <tr>

              <td
                colSpan="7"
                className="no-data"
              >
                No Jobs Found
              </td>

            </tr>

          ) : (

            filteredJobs.map((item) => (

              <tr key={item.id}>

                <td>{item.title}</td>

                <td>{item.company}</td>

                <td>{item.location}</td>

                <td>{item.salary}</td>

                <td>

                  <span
                    className={
                      item.status === "Active"
                        ? "status-active"
                        : "status-closed"
                    }
                  >
                    {item.status}
                  </span>

                </td>

                <td>{item.deadline}</td>

                <td>

<div className="action-buttons">

<button
className="view-app-btn"
onClick={() => viewApplicants(item)}
>
Applicants
</button>

<button
className="download-app-btn"
onClick={() => downloadApplicants(item)}
>
Download
</button>

<button
className="edit-btn"
onClick={() => editJob(item)}
>
Edit
</button>

<button
className="delete-btn"
onClick={() => deleteJob(item.id)}
>
Delete
</button>

</div>

                </td>

              </tr>

            ))

          )}

        </tbody>

      </table>

    </div>

    {/* Modal comes here in Part 3 */}
{/* =========================
      ADD / EDIT JOB MODAL
========================= */}

{showModal && (

<div
  className="job-modal-overlay"
  onClick={closeModal}
>

<div
  className="job-modal"
  onClick={(e) => e.stopPropagation()}
>

<div className="job-modal-header">

<h2>
  {editingId ? "Edit Job" : "Add New Job"}
</h2>

<button
  type="button"
  className="modal-close"
  onClick={closeModal}
>
  ✕
</button>

</div>

<form
  className="job-form"
  onSubmit={saveJob}
>

<div className="job-form-grid">

<input
  type="text"
  name="title"
  placeholder="Job Title"
  value={job.title}
  onChange={handleChange}
  required
/>

<input
  type="text"
  name="company"
  placeholder="Company Name"
  value={job.company}
  onChange={handleChange}
  required
/>

<input
  type="text"
  name="salary"
  placeholder="Salary Package"
  value={job.salary}
  onChange={handleChange}
  required
/>

<input
  type="text"
  name="location"
  placeholder="Location"
  value={job.location}
  onChange={handleChange}
/>

<select
  name="type"
  value={job.type}
  onChange={handleChange}
>

<option>Full Time</option>
<option>Part Time</option>
<option>Internship</option>
<option>Remote</option>

</select>

<input
  type="text"
  name="qualification"
  placeholder="Qualification"
  value={job.qualification}
  onChange={handleChange}
/>

<input
  type="text"
  name="experience"
  placeholder="Experience"
  value={job.experience}
  onChange={handleChange}
/>

<input
  type="number"
  name="vacancies"
  placeholder="Vacancies"
  value={job.vacancies}
  onChange={handleChange}
/>

<input
  type="date"
  name="deadline"
  value={job.deadline}
  onChange={handleChange}
/>

<select
  name="status"
  value={job.status}
  onChange={handleChange}
>

<option>Active</option>
<option>Closed</option>

</select>

<textarea
  rows="2"
  name="description"
  placeholder="Job Description"
  value={job.description}
  onChange={handleChange}
/>

</div>

<div className="job-form-actions">

<button
  type="submit"
  className="save-job-btn"
>

{editingId
  ? "Update Job"
  : "Add Job"}

</button>

<button
  type="button"
  className="cancel-btn"
  onClick={closeModal}
>
  

Cancel

</button>

</div>

</form>

</div>

</div>

)}
{
showApplicants && (

<div
className="job-modal-overlay"
onClick={() => setShowApplicants(false)}
>

<div
className="job-modal applicants-modal"
onClick={(e)=>e.stopPropagation()}
>

<div className="job-modal-header">

<h2>

Applicants

{selectedJob &&
` - ${selectedJob.title}`}

</h2>

<button
className="modal-close"
onClick={() => setShowApplicants(false)}
>

✕

</button>

</div>

<table className="applicant-table">

<thead>

<tr>

<th>Name</th>

<th>Email</th>

<th>Phone</th>

<th>Registration</th>

<th>Status</th>

<th>Resume</th>

</tr>

</thead>

<tbody>

{applicants.length===0 ? (

<tr>

<td colSpan="6">

No Applicants Yet

</td>

</tr>

) : (

applicants.map((app)=>(

<tr key={app.id}>

<td>{app.fullname}</td>

<td>{app.email}</td>

<td>{app.phone}</td>

<td>{app.registrationNo}</td>

<td>{app.status}</td>

<td>

<a
href={app.resume}
target="_blank"
rel="noreferrer"
>

View Resume

</a>

</td>

</tr>

))

)}

</tbody>

</table>

</div>

</div>

)
}
{
deleteModal && (

<div
className="delete_popup_overlay"
onClick={() => setDeleteModal(false)}
>


<div
className="delete_popup_card"
onClick={(e)=>e.stopPropagation()}
>


<div className="delete_popup_icon">

!

</div>


<h2>
Delete Job?
</h2>


<p>
Are you sure you want to delete this job posting?
<br/>
This action cannot be undone.
</p>



<div className="delete_popup_actions">


<button

className="delete_cancel_btn"

onClick={()=>setDeleteModal(false)}

>

Cancel

</button>




<button

className="delete_confirm_btn"

onClick={confirmDeleteJob}

>

Delete

</button>


</div>



</div>


</div>

)
}
</div>
</div>
);
}

export default AdminJobs;